var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu",on:{"click":function($event){return _vm.$emit('actionClicked')}}},[_c('li',{staticClass:"menu__item"},[_c('RouterLink',{staticClass:"menu__link capitalize",attrs:{"to":{
        name: 'admin.products.packages.package.packageItems.packageItem.edit',
        params: {
          packageId: _vm.packageItem.packageId,
          packageItemId: _vm.packageItem.id,
        },
      }}},[_vm._v(" "+_vm._s(_vm.$te('edit') ? _vm.$t('global.edit') : 'edit')+" ")])],1),_c('li',{staticClass:"menu__item"},[_c('RouterLink',{staticClass:"menu__link capitalize",attrs:{"to":{
        name: 'admin.products.packages.package.packageItems.packageItem.requirements',
        params: {
          packageId: _vm.packageItem.packageId,
          packageItemId: _vm.packageItem.id,
        },
      }}},[_vm._v(" "+_vm._s(_vm.$te('requirements') ? _vm.$t('requirements') : 'requirements')+" ")])],1),_c('li',{staticClass:"menu__item"},[_c('RouterLink',{staticClass:"menu__link capitalize",attrs:{"to":{
        name: 'admin.products.packages.package.packageItems.packageItem.delete',
        params: {
          packageId: _vm.packageItem.packageId,
          packageItemId: _vm.packageItem.id,
        },
      }}},[_vm._v(" "+_vm._s(_vm.$te('delete') ? _vm.$t('delete') : 'delete')+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }